'use client';

import {
  amplitudeSendEvent,
  GTM_NOTSET_STRING,
  getScreenName,
  pushDataLayer,
} from '@musinsa/frontend-utils';
import { SERVICE, useDeviceInfo } from '@musinsa/packages-device-detection';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { curatorQueries, SearchProductInput } from '..';
import { VirtualizedLikedProductList } from './components/VirtualizedLikedProductList';
import { VirtualizedSearchedProductList } from './components/VirtualizedSearchedProductList';

export const ProductSearch = () => {
  const [searchKeyword, setSearchKeyword] = useState('');
  const isSearchMode = searchKeyword.length > 0;
  const queryClient = useQueryClient();
  const { service } = useDeviceInfo();

  const handleSearch = (keyword: string) => {
    setSearchKeyword(keyword);
    const trimmed = keyword.trim();
    if (service === SERVICE.MUSINSA && trimmed.length > 0) {
      amplitudeSendEvent({
        action_name: 'click',
        button_name: 'goods_search',
        component_name: 'search_button',
        event_name: 'click_search_button',
        from: getScreenName(),
        name: trimmed,
        section_name: 'search_goods',
      });
      pushDataLayer('click_button', {
        brand_id: GTM_NOTSET_STRING,
        button_id: 'goods_search',
        button_name: trimmed,
        index: GTM_NOTSET_STRING,
        section_index: '1',
        section_name: 'search_goods',
      });
    }
  };

  useEffect(() => {
    if (isSearchMode) {
      queryClient.invalidateQueries({
        queryKey: curatorQueries.products.liked._def,
      });
      return;
    }
    queryClient.invalidateQueries({
      queryKey: curatorQueries.products.search._def,
    });
  }, [isSearchMode, queryClient]);

  return (
    <div className="flex flex-col flex-1 grow pb-[72px]! bg-[#F5F5F5]">
      <SearchProductInput
        keyword={searchKeyword}
        placeholder="큐레이션할 상품을 검색해 보세요."
        onChangeKeyword={(value) => handleSearch(value)}
      />
      {isSearchMode ? (
        <VirtualizedSearchedProductList keyword={searchKeyword} />
      ) : (
        <VirtualizedLikedProductList />
      )}
    </div>
  );
};
